export default "__VITE_ASSET__CRYaRiq0__ 1920w";